import { useEffect } from 'react'

export function useSEO({
  title,
  description,
  ogTitle,
  ogDescription,
  ogImage,
  canonicalPath
}) {
  useEffect(() => {
    // 1. Page Title
    if (title) {
      document.title = title
    }

    const finalDescription = description || ogDescription || 'Vikar4 er et professionelt og personligt vikarbureau i Nordjylland og Midtjylland med fleksible vikarløsninger tilpasset din virksomhed.'
    const finalOgTitle = ogTitle || title || 'Vikar4 · Vikarservice & Rekruttering'
    const finalOgDesc = ogDescription || finalDescription
    const finalOgImage = ogImage || 'https://assets.auxodev.dk/assets/7b6c8b8c-dd85-4faa-a1de-b9b48f1b2725/vikar4-logo-transparent.png'
    
    // Helper to set or create meta tag
    const setMetaTag = (attrName, attrVal, contentVal) => {
      let meta = document.querySelector(`meta[${attrName}="${attrVal}"]`)
      if (!meta) {
        meta = document.createElement('meta')
        meta.setAttribute(attrName, attrVal)
        document.head.appendChild(meta)
      }
      meta.setAttribute('content', contentVal || '')
    }

    // Standard Meta Tags
    setMetaTag('name', 'description', finalDescription)
    
    // Open Graph Meta Tags
    setMetaTag('property', 'og:title', finalOgTitle)
    setMetaTag('property', 'og:description', finalOgDesc)
    setMetaTag('property', 'og:image', finalOgImage)
    setMetaTag('property', 'og:type', 'website')
    if (typeof window !== 'undefined') {
      setMetaTag('property', 'og:url', window.location.href)
    }

    // Twitter Card Meta Tags
    setMetaTag('name', 'twitter:card', 'summary_large_image')
    setMetaTag('name', 'twitter:title', finalOgTitle)
    setMetaTag('name', 'twitter:description', finalOgDesc)
    setMetaTag('name', 'twitter:image', finalOgImage)

    // Canonical Link
    let canonicalLink = document.querySelector('link[rel="canonical"]')
    if (!canonicalLink) {
      canonicalLink = document.createElement('link')
      canonicalLink.setAttribute('rel', 'canonical')
      document.head.appendChild(canonicalLink)
    }
    if (typeof window !== 'undefined') {
      const canonicalUrl = canonicalPath 
        ? `${window.location.origin}${canonicalPath}` 
        : window.location.href.split('?')[0]
      canonicalLink.setAttribute('href', canonicalUrl)
    }
  }, [title, description, ogTitle, ogDescription, ogImage, canonicalPath])
}
